import React from 'react';
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import GiftboxPointHistoryPageComponent from '../components/point_history';
import API, { ROUTES } from "../../../commons/api/api";

const GiftboxPointHistoryPageContainer  = () => {

    const [pointHistory, setPointHistory] = useState([])
    const [loadMore, setloadMore] = useState(false)
    const [loading, setLoading] = useState(true)

    const fetchData = async (param = '') =>{
        setLoading(true)
        try {
            const {data: response} = await API.get(ROUTES.API_POINT_HISTORY+param);
            setPointHistory(response?.data);
            setLoading(false)
            if(response?.data?.current_page == response?.data?.last_page) {
                setloadMore(false)
            }else {
                setloadMore(true)
            }
        } catch (error) {
            setLoading(false)
            console.error(error.message);
        }
    }

    useEffect(() => {
        fetchData('?type=&page=1');
    }, []);
    const sortData = (param) => {
        setLoading(true)
        fetchData(param)
    }
    const fetchMore = (param) => {
        fetchData(param)
    }

    return <GiftboxPointHistoryPageComponent
        data={pointHistory}
        fetchMore={fetchMore}
        sortData={sortData}
        loading={loading}
        loadMore={loadMore}
    />;
};

export default GiftboxPointHistoryPageContainer ;
